/**
 * Values that exist only in the browser (ADR-0061). The public pages are prerendered at build time and hydrated, so
 * their first browser render must equal the HTML: the clock, the stored language and theme, a referral code in the URL
 * are read through a store whose server snapshot is the build's value, and React swaps in the real one right after
 * hydration — without a mismatch.
 */
import { useSyncExternalStore } from "react";

const never = () => () => {};

/** False while rendering on the server and while hydrating; true from the first browser render after that. */
export function useHydrated(): boolean {
  return useSyncExternalStore(
    never,
    () => true,
    () => false,
  );
}
